//
//
//
//
//
//
//
//

import WX_API from '@/utils/wx_api'
export default {
    props: {
        name: {
            type: String
        },
        add_group_url: {
            type: String
        }
    },
    methods: {
        copWx (wx) {
            WX_API.setClipboardData(this.name)
        },
        goDetail() {
            this.$sendCtmEvtLog('楼盘评论加群点击')
            this.$router.push({
                path:`/pages/building/discuess_group/main?link=${this.add_group_url}`
            })
        }
    }
}
